import React from 'react';
import PropTypes from 'prop-types';

import StyledDropdownFooter from './StyledDropdownFooter';

const DropdownFooter = ({children}) => {

	return <StyledDropdownFooter>{children}</StyledDropdownFooter>;
};

DropdownFooter.propTypes = {};

export default DropdownFooter;
